// base_info_view 3
import React, { useRef, useState, useEffect } from 'react'
import BaseInfoView3_1 from './base_info_view_3_1'
const BaseInfoView3 = ({
    baseInfoView3_1Props = {
        data: [
            {
                key: "empty_draft",
                label: "進行中/歷史 空白建立",
                total: "0/0", // 雙數字
                badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]"
            },
            {
                key: "ai_generated",
                label: "進行中/歷史 AI生成",
                total: "0/0",
                badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]"
            },
            {
                key: "system_default",
                label: "進行中/歷史 系統預設",
                total: "5/0/500", // 三段數字
                badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]"
            }],
        allLabel: "全部",
        total: 0,
        defaultValue: "",
        onChange: () => { },
        showAllLabel: true
    },
    showComponent = ['BaseInfoView3_1']
}) => {

    return (
        <>
            {showComponent.includes("BaseInfoView3_1") && (
                <BaseInfoView3_1
                    {...baseInfoView3_1Props}
                />
            )}
        </>




    )
}
export default BaseInfoView3
